module.exports = "/_next/static/resources/photo-4-90299197c8ae1cefbef53a3eedf17f81.jpg";